import React, { useState, useRef, useEffect, useContext } from 'react';
import { IonContent, IonHeader, IonTitle, IonToolbar, IonItem, IonList, IonSplitPane, IonMenuButton, IonButton, IonButtons, IonInput, IonModal, IonGrid, IonRow, IonCol, IonSlides, IonLoading } from '@ionic/react';
import { IonTabs, IonTabBar, IonTabButton, IonText, IonLabel, IonFooter, IonSlide, IonImg, IonRouterOutlet } from '@ionic/react';
import { Redirect} from 'react-router-dom';

import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';
import { EnterPasswordModal } from '../../../zInternal_Features/merchant/components/Modal_EnterPassword';
import { ShowRoomPicsModal } from './Modal_ShowRoomPics';
import { CreateInventoryRoomModal } from './Modal_CreateInventoryRoom';
import {InventoryRoomDetailsModal} from './Modal_Inventory_Room_Details';

import '../../../css/layout.css';

import { CreateInventoryItemModal } from './Modal_CreateInventoryItem';

export function Tab_Management_Inventory () {

    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);

    const [acctID, setAcctID] = useState(authenticatedMerchent_context.acctID);
    const [employeeID, setEmployeeID] = useState(authenticatedMerchent_context.employeeID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);


    let [createInventoryRoomModal, setCreateInventoryRoomModal] = useState(false);
    let [stockInventoryRoomModal, setStockInventoryRoomModal] = useState(false);
    let [deleteInventoryRoomModal, setDeleteInventoryRoomModal] = useState(false);
    let [adminPasswordCreateInventoryRoomModal, setAdminPasswordCreateInventoryRoomModal] = useState(false);
    let [showInventoryRoomDetailsModal, setShowInventoryRoomDetailsModal] = useState(false);

    let [createInventoryItemModal, setCreateInventoryItemModal] = useState(false);
    let [stockInventoryItemModal, setStockInventoryItemModal] = useState(false);
    let [deleteInventoryItemModal, setDeleteInventoryItemModal] = useState(false);
    let [adminPasswordCreateInventoryItemModal, setAdminPasswordCreateInventoryItemModal] = useState(false);
    let [adminPasswordDeleteItemModal, setAdminPasswordDeleteItemModal] = useState(false);

    let [selectedFile, seteSlectedFile] = useState(null);

    let [viewRoomDetailsData, setViewRoomDetailsData] = useState([]);
    let [viewRoomItemsDetailsData, setViewRoomItemsDetailsData] = useState([]);

    let [viewItemDetailsData, setViewItemDetailsData] = useState([]);

    let [quantityAddedToRoom, setQuantityAddedToRoom] = useState(null);
    let [quantityReplenishedStock, setQuantityReplenishedStock] = useState(null);

    let [inventoryAccessCheckboxValue, setInventoryAccessCheckboxValue] = useState(null);

    let [roomID, setRoomID] = useState(null);
    let [roomType, setRoomType] = useState(null);
    let [roomPartNum, setRoomPartNum] = useState(null);
    let [roomPhoneNumber, setRoomPhoneNumber] = useState(null);
    let [roomCostPerUnit, setRoomCostPerUnit] = useState(null);
    let [roomSalePrice, setRoomSalePrice] = useState(null);
    let [roomPic1, setRoomPic1] = useState("/var/www/web/Public/fileServer/merchants/image-not-available.jpg");
    let [roomPic2, setRoomPic2] = useState("/var/www/web/Public/fileServer/merchants/image-not-available.jpg");
    let [roomPic3, setRoomPic3] = useState("/var/www/web/Public/fileServer/merchants/image-not-available.jpg");
    let [roomPic4, setRoomPic4] = useState("/var/www/web/Public/fileServer/merchants/image-not-available.jpg");
    let [roomPicsModal, setRoomPicsModal] = useState(false);
    let [roomDateCreated, setRoomDateCreated] = useState(null);
    let [roomAddedBy, setRoomAddedBy] = useState(null);
    let [roomIsActivated, setRoomIsActivated] = useState(null);

    let [inventory_roomsTab_data, setInventory_roomsTab_data] = useState('true');
    let [inventory_itemsTab_data, setInventory_itemsTab_data] = useState('false');

    let [inventory_roomsTab_view, setInventory_roomsTab_view] = useState('outline')
    let [inventory_itemsTab_view, setInventory_itemsTab_view] = useState('clear')

    let [itemID, setItemID] = useState(null);
    let [itemName, setItemName] = useState(null);
    let [attachment, setAttachment] = useState(null);
    let [createdByEmployee, setCreatedByEmployee] = useState(null);

    let [viewInventoryRoomMainDetailsData, setViewInventoryRoomMainDetailsData] = useState([]);
    let [viewInventoryItemMainDetailsData, setViewInventoryItemMainDetailsData] = useState([]);

    let [searchInventoryItem, setSearchInventoryItem] = useState(null);
    let [enterAdminPassword, setEnterAdminPassword] = useState(null);
    let [showRoomPics, setShowRoomPics] = useState(false);
    let [showRoomDetails, setShowRoomDetails] = useState(false);
    let [activateRoomButton, setActivateRoomButton] = useState('inline-block');
    let [deactivateRoomButton, setDeactivateRoomButton] = useState('inline-block');

    let [passwordCategory, setPasswordCategory] = useState(null);
    let [showPasswordModal, setShowPasswordModal] = useState(false);

    let [searchResults, setSearchResults] = useState([]);

    let [isloading, setLoading] = useState(false);

    let roomItemNameRef = useRef('');
    let itemNameRef = useRef('');

    let slideRef = useRef(null);



    function updateDeleteInventoryRoomModal(event) {

        if(event)
        {
            setDeleteInventoryRoomModal(event);
        }
        else
        {

            setDeleteInventoryRoomModal(event);
            setViewRoomDetailsData([]);
            setViewRoomItemsDetailsData([]);

        }
    }


    function searchList(event)
    {
        let searchCategory = event[0];
        let searchData = event[1];

        first_searchSuppliersInDB(searchCategory, searchData);

    }

    function first_searchSuppliersInDB(searchCategory, searchData, optionsData)
    {

        let formData = new FormData();
        let Tracker = '';

        //alert('Inside search room category');
        //alert(searchCategory);
        //alert(searchData);

        /*if(searchCategory === 'name')
        {

            Tracker = '74002S_N';
        }
        else if(searchCategory === 'phone')
        {
            Tracker = '74002S_P';

        }*/

        if(searchCategory === 'stock_room_item')
        {

            Tracker = '74302';
        }
        else if(searchCategory === 'delete_stock_room_item')
        {

            Tracker = '74304';

        }
        else if(searchCategory === 'stock_item' || searchCategory === 'delete_stock_item')
        {
            Tracker = '74402';
        }


        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: Tracker,
                user: acctID,
                xInventorySearchItem: searchData,
                sessionID: sessionID,
            })
        }

        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {

                        let rows = res.toString().split('~~~');

                        let rowLength = rows.length;

                            for (let rownum = 0; rownum < rowLength - 1; ++rownum)
                            {
                                let cols = rows[rownum].split('|');

                                setSearchResults((prevSearchResults) => {
                                    return prevSearchResults.concat({
                                        db_itemId: cols[0],
                                        db_itemName: cols[1],
                                        db_itemDescription: cols[2],
                                        db_vendorPartNumber: cols[3],
                                        db_vendorName: cols[4],
                                        db_vendorPhoneNumber: cols[5],
                                        db_vendorAddress: cols[6],
                                        db_vendorCity: cols[7],
                                        db_vendorCountry: cols[8],
                                        db_costPerUnit: cols[9],
                                        db_qtyInStock: cols[10],
                                        db_qtyInUse: cols[101],
                                        db_dateCreated: cols[12],
                                        db_attachment: cols[13],

                                    })
                                });
                            }

                    })
        }


    function getDataRoomMain() {
            
        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: 74301,
                user: acctID,
                sessionID: sessionID,
            }),
        }
        
        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {

            let rows = res.toString().split('~~~');

            for (let rownum = 0; rownum < rows.length - 1; ++rownum)
            {
                let cols = rows[rownum].split('|');

                setViewInventoryRoomMainDetailsData((prevViewInventoryRoomMainDetailsData) => {
                    return prevViewInventoryRoomMainDetailsData.concat({
                        roomID: cols[0],
                        roomType: cols[1],
                        roomPartNum: cols[2],
                        roomPhoneNumber: cols[3],
                        roomCostPerUnit: parseFloat(cols[4]).toFixed(2),
                        roomSalePrice: parseFloat(cols[5]).toFixed(2),
                        roomPic1: cols[6],
                        roomPic2: cols[7],
                        roomPic3: cols[8],
                        roomPic4: cols[9],
                        roomDateCreated: cols[10],
                        roomAddedBy: cols[11],
                        roomIsActivated: cols[12],
                    })
                });

            } 

            setLoading(false);
        })
        
}

function updateShowRoomDetails(event) {

        // alert(event);
        // alert(event[1]);

        setRoomID(event[1]);
        setShowInventoryRoomDetailsModal(true);
}



function roomPicsModalHandler(event) {
    setRoomPic1(event[1]);
    setRoomPic2(event[2]);
    setRoomPic3(event[3]);
    setRoomPic4(event[4]);
    setRoomID(event[5]);
    setRoomSalePrice(event[6]);
    setRoomPicsModal(event[0]);

}

function setShowPasswordModalHandler(event)
{
    setPasswordCategory(event[1]);
    setShowPasswordModal(event[0]);

}
function hotelInventory_roomsHandler()
{
    setInventory_roomsTab_data(true);
    setInventory_itemsTab_data(false);

    setInventory_roomsTab_view('outline');
    setInventory_itemsTab_view('clear');



}
function hotelInventory_itemsHandler()
{
    setInventory_roomsTab_data(false);
    setInventory_itemsTab_data(true);

    setInventory_roomsTab_view('clear');
    setInventory_itemsTab_view('outline');

}

async function handleSlideChange()
{

    let swiper = await slideRef.current?.getSwiper();

    //let activeIndex = swiper?.activeIndex; // Get the current slide index

    let realIndex = swiper?.realIndex; // Get the actual slide index (ignores duplicate slides)

    //alert(realIndex);

    if (realIndex === 0) { // Example: Execute a function when reaching slide 3
        hotelInventory_roomsHandler();
    }
    else if (realIndex === 1) { // Example: Execute a function when reaching slide 3
        hotelInventory_itemsHandler();
    }
  };

  const slideOpts = {
    initialSlide: 0, // Start at the first slide
    speed: 100, // Animation speed (in ms)
    loop: false, // Enable looping
  };



useEffect(() =>  {

    setLoading(true);

        
        getDataRoomMain();   

}, [])

//alert('In Management _ Inventory');
//alert(acctID);
//alert(authenticatedMerchent_context.accessRights[0]);
//alert(authenticatedMerchent_context.device);

        return (

            <React.Fragment>

            <IonItem>
                <IonGrid>
                    <IonRow style={{color: 'black'}}>
                        <IonCol size='12'>
                            <IonButton className='tab_buttons' fill={inventory_roomsTab_view} onClick={() => slideRef.current?.slideTo(0, 100)}> <IonLabel>Rooms</IonLabel> </IonButton>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonItem>

            <IonContent className='grid_content'>
                <IonGrid>
                    <IonRow >
                            <IonCol >Room ID</IonCol>
                            <IonCol >Room Type</IonCol>
                            {/*<IonCol >Part Number</IonCol>*/}
                            {/*<IonCol >Phone Number</IonCol>*/}
                            <IonCol >Cost Price</IonCol>
                            <IonCol >Sale Price</IonCol>                                        
                            {/*<IonCol >Date Created</IonCol>*/}
                            {/*<IonCol >Created By</IonCol>*/}
                            <IonCol >Action</IonCol>
                    </IonRow>
                {viewInventoryRoomMainDetailsData.map((detailData) =>   {
                    return (
                        <IonRow >
                            <IonCol >{detailData.roomID}</IonCol>
                            <IonCol >{detailData.roomType}</IonCol>
                            {/*<IonCol >{detailData.roomPartNum}</IonCol>detailData*/}
                            {/*<IonCol >{detailData.roomPhoneNumber}</IonCol>*/}
                            <IonCol >{detailData.roomCostPerUnit}</IonCol>
                            <IonCol >{detailData.roomSalePrice}</IonCol>
                            {/*<IonCol >{detailData.roomDateCreated}</IonCol>*/}
                            {/*<IonCol >{detailData.roomAddedBy}</IonCol>*/}
                            <IonCol >
                                <IonButton  onClick={() => roomPicsModalHandler([true, detailData.roomPic1, detailData.roomPic2, detailData.roomPic3, detailData.roomPic4, detailData.roomID, detailData.roomSalePrice])}> Images </IonButton>
                                {authenticatedMerchent_context.accessRights[0] == 'admin' && <IonButton  onClick={() => updateShowRoomDetails([true, detailData.roomID, detailData.roomIsActivated])}> Details </IonButton>}
                            </IonCol>
                        </IonRow>
                    )
                }
                )}
                <IonRow>
                    <IonCol size='6'>
                        {authenticatedMerchent_context.initialSetup?.details?.step_2 == false && <IonButton  className='flash-tutorial' onClick={() =>  setCreateInventoryRoomModal(true)}>Create Room</IonButton>}
                        {authenticatedMerchent_context.initialSetup?.details?.step_2 == true && <IonButton onClick={() =>  setCreateInventoryRoomModal(true)}>Create Room</IonButton>}
                    </IonCol>
                    <IonCol size='6'>
                        <IonButton onClick={() => updateDeleteInventoryRoomModal(true)}>Delete Room </IonButton>
                    </IonCol>
                </IonRow>

            </IonGrid>

                {roomPicsModal == true &&  <ShowRoomPicsModal openModal={ roomPicsModal } closeModal={() => setRoomPicsModal(false)} data={{
                        roomPic1: roomPic1, 
                        roomPic2: roomPic2, 
                        roomPic3: roomPic3, 
                        roomPic4: roomPic4, 
                        roomID: roomID, 
                        roomSalePrice: roomSalePrice
                        }}>
                    </ShowRoomPicsModal>}
                        
               {createInventoryRoomModal == true && <CreateInventoryRoomModal  openModal={ createInventoryRoomModal } closeModal={() => setCreateInventoryRoomModal(false)}></CreateInventoryRoomModal>}
               {showInventoryRoomDetailsModal == true && <InventoryRoomDetailsModal openModal={ showInventoryRoomDetailsModal } closeModal={() => setShowInventoryRoomDetailsModal(false)} data={{
                    roomID: roomID, 
                                        }}></InventoryRoomDetailsModal>}

                {isloading == true && <IonLoading
                        isOpen={isloading}
                        message={'Please wait...'}
                        duration={0} // Show until manually dismissed
                    />}
                
                </IonContent>

            </React.Fragment>
        )
    }   